// extracted by mini-css-extract-plugin
export default {"hr":"HorizonalLine_hr__osDyq"};